import React from 'react';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppLocationsService from '../AppLocationsService';

//global component
import ModalButton from '../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
} from '../../../SharedStyles';

const DeleteModal = (props) => {
  const { handleCloseModal, loc, handleDeleting } = props;
  const { strings } = AppLocationsService;

  const closeModal = () => {
    handleCloseModal();
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    handleDeleting(loc.id);
    handleCloseModal();
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.deleteModalTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0 10px'>
            <p>
              {strings.deleteModalContentOne} ({loc.meterGroupCount}){' '}
              {strings.deleteModalContentTwo}
            </p>
          </ModalItemStyles>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          handleClick={handleSaveInfo}
          buttonText={strings.deleteModalButton}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default DeleteModal;
